// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f71b0109","821":"9999f0b4","977":"345d6f04"}[chunkId] + ".chunk.js";
};